/* global YT */

const SELECTOR = '[data-youtube-id]';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    window.onYouTubeIframeAPIReady = () => {
        elements.forEach(node => {
            const videoId = node.getAttribute('data-youtube-id');
            let initialPlay = true;

            const player = new YT.Player(node.id, {
            videoId: videoId,
            playerVars: {
                controls: node.getAttribute('data-show-controls') || 1,
                autoplay: 1,
                mute: 1,
                disablekb: node.getAttribute('data-disable-keyboard') || 0,
                enablejsapi: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                height: node.getAttribute('data-width') || '1200',
                width: node.getAttribute('data-height') || '675'

            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
            });

            // 4. The API will call this function when the video player is ready.
            function onPlayerReady() {
                player.playVideo();
            }

            // 5. The API calls this function when the player's state changes.
            //    The function indicates that when playing a video (state=1),
            //    the player should play for six seconds and then stop.
            function onPlayerStateChange(event) {
                if (event.data === YT.PlayerState.PLAYING) {
                    if (initialPlay) {
                        player.seekTo(0);
                        document.getElementById(node.id).classList.add('article-header__video--loaded');
                        initialPlay = false;
                    }
                }

                if (event.data === YT.PlayerState.ENDED) {
                    player.seekTo(0);
                    player.playVideo();
                }
            }
        });
    }

    // Insert JS tag (<script src="https://www.youtube.com/iframe_api"></script>)
    const tag = document.createElement('script');
    tag.setAttribute('src', 'https://www.youtube.com/iframe_api');
    document.head.appendChild(tag);
}
